/**
 * Labels para os 4 módulos de propostas (espelha `functions/lib/engine/types.ts`
 * que vive em outro tsconfig — não importável daqui).
 */
export const KIND_LABEL_PT = {
  solar: "Kit Solar",
  ac: "Ar Condicionado",
  bc_aqs: "Bomba Calor AQS",
  bc_aq: "Bomba Calor Aquec.",
} as const

export type Kind = keyof typeof KIND_LABEL_PT

export const KIND_VALUES: Kind[] = ["solar", "ac", "bc_aqs", "bc_aq"]

/**
 * Detail-page route for a proposal of a given kind.
 */
export function detailPathForKind(
  kind: Kind,
  id: number | string,
): string | null {
  switch (kind) {
    case "solar": return `/solar/${id}`
    case "bc_aqs": return `/bc-aqs/${id}`
    case "bc_aq": return `/bc-aq/${id}`
    case "ac": return `/ac/${id}`
    default: return null
  }
}

/**
 * Edit-page route for a proposal of a given kind. Returns null for kinds
 * without a dedicated edit page yet (caller hides the "Editar dados" action).
 */
export function editPathForKind(
  kind: Kind,
  id: number | string,
): string | null {
  switch (kind) {
    case "solar": return `/solar/${id}/editar`
    case "ac": return `/ac/${id}/editar`
    case "bc_aqs": return `/bc-aqs/${id}/editar`
    case "bc_aq": return `/bc-aq/${id}/editar`
    default: return null
  }
}
